export const initialSubjectName = '';
